// extracted by mini-css-extract-plugin
export default {"horizontal":"AppMenu_horizontal__pTowk","vertical":"AppMenu_vertical__D9a9K","active":"AppMenu_active__-IUtc"};